import { gql } from "@apollo/client";

export const GET_ENVIO = gql`
  query GetEnvio($idOrdenPedido: Int!, 
              $idEvaluacion: Int!) {
    envio(idOrdenPedido: $idOrdenPedido, 
          idEvaluacion: $idEvaluacion
          ) {
      cabecera {
        idOrdenPedido,
        idEvaluacion,
        idDelegacion,
        delegacion,
        paciente,
        hC,
        edad,
        fechaNacimiento,
        codSAPPaciente,
        cobertura,
        idDeposito,
        deposito,
        almacenSAP,
        centroSAP,
        idEstadoEnvio,
        estadoEnvio,
        fechaAlta,
        diasPedido,
        idCliente,
        fechaEntrega,
        diasCO,
        diasFacturacion,
        complejidadPlan,
        maxDiasCO,
        idResultadoPresupuesto
        tieneSuspensionObito
        motivoSuspension
        estadoAsistencial
      },
      ubicacion {
        idOrdenPedidoEnvio,
        idOrdenPedido,
        idEvaluacion,
        direccion,
        codigoPostal,
        localidad,
        provincia,
        pais,
        telefono,
        observaciones
      },
      contrato {
        idEvaluacion,
        fechaDesde,
        fechaHasta,
        planCuidado,
        conexionesSemanales
      },
      indicaciones {
        idIndicacion,
        fechaDesde,
        fechaHasta,
        usuario,
        fechaAlta,
        insumos {
          idIndicacion,
          idInsumoN,
          insumo,
          cantidad,
          unidad
        }
      },
      solicitudIndicacion {
        idIndicacionAprobacion,
        fechaDesde,
        fechaHasta,
        fechaAlta,
        solicitante,
        insumos {
          idIndicacion,
          idInsumoN,
          insumo,
          cantidad,
          unidad
        }
      },
      insumos {
        idInsumoN,
        idInsumo,
        descripcion,
        por,
        cantidadPlan,
        cantidadDiaria,
        cantidadAPedir,
        indFutura
      }
    }
  }
`;